import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { KYMW7402Component } from './kymw7402.component';
import { GetFixedOrderListService } from './api-services/get-fixed-order-list.service';
import { GetGoodsCoopByItemCodeService } from './api-services/get-goods-coop-by-item-code.service';
import { GetRememberGoodsInfoService } from './api-services/get-remember-goods-info.service';
import { GetRememberOrderNumService } from './api-services/get-remember-order-num.service';
import { UpdateRememberGoodsInfoForFixedService } from './api-services/update-remember-goods-info-for-fixed.service';
import { UpdateRememberGoodsInfoService } from './api-services/update-remember-goods-info.service';
import { GetOldCatalogProgressCatalogInfo } from './api-services/get-old-catalog-progress-catalog-info.service';

/**
 * 忘れず注文商品商品登録 モジュール設定クラス
 *
 * @export KYMW7402Module
 * @class KYMW7402Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjInputModule,
  ],
  declarations: [
    KYMW7402Component,
  ],
  providers: [
    GetFixedOrderListService,
    GetGoodsCoopByItemCodeService,
    GetRememberGoodsInfoService,
    GetRememberOrderNumService,
    UpdateRememberGoodsInfoForFixedService,
    UpdateRememberGoodsInfoService,
    GetOldCatalogProgressCatalogInfo,
  ],
})
export class KYMW7402Module {

}